import { Injectable } from '@angular/core';

@Injectable()
export class QueryString {
  static toObject (params: URLSearchParams): { [key: string]: string } {
    const result: { [key: string]: string } = {};
    params.forEach((value, key) => {
      result[key] = value;
    });
    return result;
  }

  static safeSearchParamsFromUrl (url: string): URLSearchParams {
    // Prefer URL parsing (more robust), but fall back to a simple "?" split
    // for unexpected input that fails URL construction.
    try {
      const decodedUrl = decodeURI(url);
      const urlObj = new URL(decodedUrl);
      return new URLSearchParams(urlObj.search.slice(1));
    } catch {
      const queryIndex = url.indexOf('?');
      const queryString = queryIndex >= 0 ? url.substring(queryIndex + 1) : '';
      return new URLSearchParams(queryString);
    }
  }

  static buildForwardedQueryString (url: string, keysToStrip: string[]): string {
    const extraParams = QueryString.safeSearchParamsFromUrl(url);
    keysToStrip.forEach((key) => extraParams.delete(key));
    return extraParams.toString();
  }

  static appendQueryString (baseUrl: string, queryString: string): string {
    if (!queryString) {
      return baseUrl;
    }

    const separator = baseUrl.includes('?') ? '&' : '?';
    return baseUrl + separator + queryString;
  }

  private _queryString: Object = {};
  private _query: string = window.location.search.substring(1);
  private _vars: string[] = this._query.split('&');

  public getQueryString (url?: string): Object {
    this._queryString = {};

    if (url) {
      this._query = url.split('?')[1];

      if (this._query) {
        this._vars = this._query.split('&');
      } else {
        this._vars = [];
      }
    }

    for (let value of this._vars) {
      let pair = value.split('=');

      // If first entry with this name
      if (typeof (<any> this._queryString)[pair[0]] === 'undefined') {
        this._queryString[pair[0]] = decodeURIComponent(pair[1]);

        // If second entry with this name
      } else if (typeof (<any> this._queryString)[pair[0]] === 'string') {
        let arr = [(<any> this._queryString)[pair[0]], decodeURIComponent(pair[1])];
        (<any> this._queryString)[pair[0]] = arr;
        // If third or later entry with this name
      } else {
        (<any> this._queryString)[pair[0]].push(decodeURIComponent(pair[1]));
      }
    }

    return this._queryString;

  }

}
